import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "flex justify-start" }
const _hoisted_3 = {
  class: "mr-3 my-1",
  style: {"width":"10px"}
}
const _hoisted_4 = { class: "ml-2 mr-6 time text-center" }
const _hoisted_5 = { class: "flex justify-end flex-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "secondarySlotsWrapper"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "ml-2 mr-6 time text-center" }
const _hoisted_9 = { class: "flex justify-end flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.combainedDoctorVariants.length > 1)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              class: "triangle block",
              style: _normalizeStyle(_ctx.iconRotationStyle),
              color: "black",
              size: 10,
              onClick: _ctx.toggleCards
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-triangle", -1)
              ]))]),
              _: 1
            }, 8, ["style", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "flex justify-between slotTimeCard",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectSlot(_ctx.combainedDoctorVariants[0])))
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.combainedDoctorVariants[0].time), 1),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combainedDoctorVariants[0].doctors, (doc) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "doctorCell",
              style: _normalizeStyle({ backgroundColor: `${doc.color}`})
            }, [
              _createTextVNode(_toDisplayString(doc.name) + " ", 1),
              (doc.isOverlap)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    title: "Overlapped",
                    color: "white",
                    size: 17
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode(" mdi-information ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 4))
          }), 256))
        ])
      ])
    ]),
    (_ctx.combainedDoctorVariants.length > 1 && _ctx.isVariantsOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combainedDoctorVariants, (variant) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex justify-between my-1 slotTimeCard",
              onClick: ($event: any) => (_ctx.selectSlot(variant))
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(variant.time), 1),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.doctors, (doc) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "doctorCell",
                    style: _normalizeStyle({ backgroundColor: `${doc.color}`})
                  }, [
                    _createTextVNode(_toDisplayString(doc.name) + " ", 1),
                    (doc.isOverlap)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          title: "Overlapped",
                          color: "white",
                          size: 17
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" mdi-information ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 4))
                }), 256))
              ])
            ], 8, _hoisted_7))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}